<template>
  <!-- 分页 -->
  <div :class="{ bottomTool: isDialog, bottomTool1: !isDialog }">
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      @prev-click="handlePrevChange"
      @next-click="handleNextChange"
      :current-page="customPagination.currentPage"
      :page-sizes="pageSizes"
      :page-size="customPagination.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="customPagination.total"
    >
    </el-pagination>
  </div>
</template>

<script>
export default {
  name: "PaginationTool",
  props: {
    pagination: Object,
    isLoading: Boolean,
    StudentClassAllocation: {
      type: Boolean,
      default: false,
    },
    isDialog: {
      type: Boolean,
      default: true,
    },
    pageSizes: {
      type: Array,
      default: () => [20, 50, 100,200,500,1000]
    }
  },
  data() {
    return {
      customPagination: this.pagination,
    };
  },
  watch: {
    pagination: {
      handler(newVal) {
        if (newVal) {
          this.customPagination = newVal;
        }
      },
      deep: true,
    },
    // 监听total的数据变化,等父组件中该值改变后再渲染到子组件页面上
    "customPagination.total": {
      handler(newVal, olVal) {
        if (newVal) {
          this.getPageSizesData();
        }
      },
      deep: true,
    },
    //监听页码变化
    "customPagination.currentPage"(newVal) {
      this.pagination.currentPage = newVal;
      this.refreshTable();
    },
    //监听分页数量的变化
    "customPagination.pageSize"(newVal) {
      this.pagination.pageSize = newVal;
      this.refreshTable();
    },
  },
  methods: {
    //刷新表格数据
    refreshTable(val) {
      if (!this.isLoading) {
        //直接执行父组件中的更新列表方法
        this.$emit("change-pagination", this.customPagination);
      }
    },
    // 计算customPagination.pageSizes
    getPageSizesData() {
      if (this.StudentClassAllocation) return;
      const pageSize = this.customPagination.pageSize;
      const pageCount = Math.ceil(this.customPagination.total / pageSize);
      let array = [];
      for (let i = 0; i < pageCount; i++) {
        let item = (i + 1) * pageSize;
        array.push(item);
      }
      this.customPagination.pageSizes = array;
    },
    // 每页数量
    handleSizeChange(val) {
      this.customPagination.pageSize = val;
      this.pagination.currentPage = 1;
      this.eventTrigger();
    },
    // 前往x页
    handleCurrentChange(val) {
      this.customPagination.currentPage = val;
      this.eventTrigger();
    },
    // 往前一页
    handlePrevChange(val) {
      this.customPagination.currentPage = val;
      this.eventTrigger();
    },
    // 往后一页
    handleNextChange(val) {
      this.customPagination.currentPage = val;
      this.eventTrigger();
    },
    // 向父组件发送事件
    eventTrigger() {
      if (!this.isLoading) {
        this.$emit("change-pagination", this.customPagination);
      }
    },
  },
};
</script>

<style scoped>
.bottomTool {
  position: fixed;
  bottom: 10px;
}
.bottomTool1 {
  /* position: fixed; */
  bottom: 10px;
}
</style>
